import React from 'react';
import { MapPin, Bed, Bath, Ruler, Home } from 'lucide-react';
interface PropertyCardProps {
  title: string;
  price: string;
  location: string;
  beds: number;
  baths: number;
  area: string;
  matchPercentage: number;
  image?: string;
  onShareWhatsApp?: () => void;
  onMarkAsSent?: () => void;
  onArchive?: () => void;
}
export function PropertyCard({
  title,
  price,
  location,
  beds,
  baths,
  area,
  matchPercentage,
  image,
  onShareWhatsApp,
  onMarkAsSent,
  onArchive
}: PropertyCardProps) {
  return <div className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100" data-id="element-82">
      {/* Image */}
      <div className="relative h-40 bg-gray-200" data-id="element-83">
        {image ? <img src={image} alt={title} className="w-full h-full object-cover" data-id="element-84" /> : <div className="w-full h-full flex items-center justify-center text-gray-400" data-id="element-85">
            <Home className="w-12 h-12" data-id="element-86" />
          </div>}
        <div className="absolute top-3 right-3 bg-accent text-primary text-xs font-bold px-3 py-1 rounded-full shadow-sm" data-id="element-87">
          {matchPercentage}% Match
        </div>
      </div>

      {/* Content */}
      <div className="p-4" data-id="element-88">
        <h3 className="font-bold text-neutral-text text-base mb-2 line-clamp-1" data-id="element-89">
          {title}
        </h3>

        <p className="text-lg font-bold text-secondary mb-3" data-id="element-90">{price}</p>

        <div className="flex items-center text-gray-500 text-sm mb-4" data-id="element-91">
          <MapPin className="w-4 h-4 mr-1 flex-shrink-0" data-id="element-92" />
          <span className="line-clamp-1" data-id="element-93">{location}</span>
        </div>

        {/* Property Details */}
        <div className="flex items-center gap-4 pb-4 border-b border-gray-100" data-id="element-94">
          <div className="flex items-center gap-1.5 text-gray-600" data-id="element-95">
            <Bed className="w-4 h-4 text-gray-400" data-id="element-96" />
            <span className="text-sm font-medium" data-id="element-97">{beds}</span>
          </div>
          <div className="flex items-center gap-1.5 text-gray-600" data-id="element-98">
            <Bath className="w-4 h-4 text-gray-400" data-id="element-99" />
            <span className="text-sm font-medium" data-id="element-100">{baths}</span>
          </div>
          <div className="flex items-center gap-1.5 text-gray-600" data-id="element-101">
            <Ruler className="w-4 h-4 text-gray-400" data-id="element-102" />
            <span className="text-sm font-medium" data-id="element-103">{area}</span>
          </div>
        </div>

        {/* Single Action Button */}
        <button onClick={onShareWhatsApp} className="w-full mt-4 py-3 bg-green-500 hover:bg-green-600 text-white rounded-xl transition-colors font-semibold text-sm" data-id="element-104">
          Share via WhatsApp
        </button>
      </div>
    </div>;
}